document.addEventListener("DOMContentLoaded", function() {
  
  
    const ajaxCart = {
      
      
      
        init: function() {
            this._initAddToCart();
          
          this.selectors = {
            addToCart: '[data-add-to-cart]',
            addToCartText: '[data-add-to-cart-text]',
            cartCount: '[data-cart-count]',
            cartCountBubble: '[data-cart-count-bubble]',
            cartPopup: '[data-cart-popup]',
            cartPopupCartQuantity: '[data-cart-popup-cart-quantity]',
            cartPopupClose: '[data-cart-popup-close]',
            cartPopupDismiss: '[data-cart-popup-dismiss]',
            cartPopupImage: '[data-cart-popup-image]',
            cartPopupImageWrapper: '[data-cart-popup-image-wrapper]',
            cartPopupImagePlaceholder: '[data-image-loading-animation]',
            cartPopupProductDetails: '[data-cart-popup-product-details]',
            cartPopupQuantity: '[data-cart-popup-quantity]',
            cartPopupQuantityLabel: '[data-cart-popup-quantity-label]',
            cartPopupTitle: '[data-cart-popup-title]',
            cartPopupWrapper: '[data-cart-popup-wrapper]',
            loader: '[data-loader]',
            loaderStatus: '[data-loader-status]',
            quantity: '[data-quantity-input]',
            SKU: '.variant-sku',
            productStatus: '[data-product-status]',
          };
          
          this.classes = {
            cartPopupWrapperHidden: 'cart-popup-wrapper--hidden',
            hidden: 'hide',
            visibilityHidden: 'visibility-hidden',
            inputError: 'input--error',
            jsZoomEnabled: 'js-zoom-enabled',
            productOnSale: 'price--on-sale',
            productUnitAvailable: 'price--unit-available',
            productUnavailable: 'price--unavailable',
            productSoldOut: 'price--sold-out',
            cartImage: 'cart-popup-item__image',
            productFormErrorMessageWrapperHidden:
              'product-form__error-message-wrapper--hidden',
            activeClass: 'active-thumb',
            variantSoldOut: 'product-form--variant-sold-out'
          };
          
          this.eventHandlers = {};
          
        },
      
      	_initAddToCart: function() {

          var productForm = document.querySelectorAll(".product-form");
          
          productForm.forEach( el => {

          	el.addEventListener(
            'submit',
              function(evt) {		
                  evt.preventDefault();

                  //this._handleButtonLoadingState(true);
                  //var form = this.container.querySelector(this.selectors.productForm);
                  this._addItemToCart(el);
                  return;

              }.bind(this)
            );
          })

        },
      
      	_addItemToCart: function(form) {
          var self = this;

          fetch('/cart/add.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: theme.Helpers.serialize(form)
          })
            .then(function(response) {
              return response.json();
            })
            .then(function(json) {
              if (json.status && json.status !== 200) {
                var error = new Error(json.description);
                error.isFromServer = true;
                throw error;
              }
              //self._hideErrorMessage();
              	self._setupCartPopup(json);
            })
            .catch(function(error) {

              console.log(error);
            });
        },
      
       _setupCartPopup: function(item) {
          this.cartPopup =
            this.cartPopup || document.querySelector(this.selectors.cartPopup);
          this.cartPopupWrapper =
            this.cartPopupWrapper ||
            document.querySelector(this.selectors.cartPopupWrapper);
          this.cartPopupTitle =
            this.cartPopupTitle ||
            document.querySelector(this.selectors.cartPopupTitle);
          this.cartPopupQuantity =
            this.cartPopupQuantity ||
            document.querySelector(this.selectors.cartPopupQuantity);
          this.cartPopupQuantityLabel =
            this.cartPopupQuantityLabel ||
            document.querySelector(this.selectors.cartPopupQuantityLabel);
          this.cartPopupClose =
            this.cartPopupClose ||
            document.querySelector(this.selectors.cartPopupClose);
          this.cartPopupDismiss =
            this.cartPopupDismiss ||
            document.querySelector(this.selectors.cartPopupDismiss);
          this.cartPopupImagePlaceholder =
            this.cartPopupImagePlaceholder ||
            document.querySelector(this.selectors.cartPopupImagePlaceholder);

          this._setupCartPopupEventListeners();

          this._updateCartPopupContent(item);
        },

        _updateCartPopupContent: function(item) {
          var self = this;

          var quantity = this.quantityInput ? this.quantityInput.value : 1;

          var selling_plan_name = item.selling_plan_allocation
            ? item.selling_plan_allocation.selling_plan.name
            : null;

          this.cartPopupTitle.textContent = item.product_title;
          this.cartPopupQuantity.textContent = quantity;
          this.cartPopupQuantityLabel.textContent = theme.strings.quantityLabel.replace(
            '[count]',
            quantity
          );

          this._setCartPopupPlaceholder(item.featured_image.url);
          this._setCartPopupImage(item.featured_image.url, item.featured_image.alt);
          this._setCartPopupProductDetails(
            item.product_has_only_default_variant,
            item.options_with_values,
            item.properties,
            selling_plan_name
          );

          fetch('/cart.js', { credentials: 'same-origin' })
            .then(function(response) {
              return response.json();
            })
            .then(function(cart) {
              self._setCartQuantity(cart.item_count);
              self._setCartCountBubble(cart.item_count);
              self._showCartPopup();
            })
            .catch(function(error) {
              // eslint-disable-next-line no-console
              console.log(error);
            });
        },
      
      	_setCartPopupPlaceholder: function(imageUrl) {
          this.cartPopupImageWrapper =
            this.cartPopupImageWrapper ||
            document.querySelector(this.selectors.cartPopupImageWrapper);

          if (imageUrl === null) {
            this.cartPopupImageWrapper.classList.add(this.classes.hidden);
            return;
          }
        },
      
       _setCartPopupImage: function(imageUrl, imageAlt) {
          if (imageUrl === null) return;

          this.cartPopupImageWrapper.classList.remove(this.classes.hidden);
          var sizedImageUrl = theme.Images.getSizedImageUrl(imageUrl, '200x');
          var image = document.createElement('img');
          image.src = sizedImageUrl;
          image.alt = imageAlt;
          image.classList.add(this.classes.cartImage);
          image.setAttribute('data-cart-popup-image', '');

          image.onload = function() {
            this.cartPopupImagePlaceholder.removeAttribute(
              'data-image-loading-animation'
            );
            this.cartPopupImageWrapper.innerHTML = "";
            this.cartPopupImageWrapper.append(image);
          }.bind(this);
        },
      
      	_setCartPopupProductDetails: function(
          product_has_only_default_variant,
          options,
          properties,
          selling_plan_name
        ) {
          this.cartPopupProductDetails =
            this.cartPopupProductDetails ||
            document.querySelector(this.selectors.cartPopupProductDetails);
          var variantPropertiesHTML = '';

          if (!product_has_only_default_variant) {
            variantPropertiesHTML =
              variantPropertiesHTML + this._getVariantOptionList(options);
          }

          if (selling_plan_name) {
            variantPropertiesHTML =
              variantPropertiesHTML + this._getSellingPlanHTML(selling_plan_name);
          }

          if (properties !== null && Object.keys(properties).length !== 0) {
            variantPropertiesHTML =
              variantPropertiesHTML + this._getPropertyList(properties);
          }

          if (variantPropertiesHTML.length === 0) {
            this.cartPopupProductDetails.innerHTML = '';
            this.cartPopupProductDetails.setAttribute('hidden', '');
          } else {
            this.cartPopupProductDetails.innerHTML = variantPropertiesHTML;
            this.cartPopupProductDetails.removeAttribute('hidden');
          }
        },
      
        _setCartQuantity: function(quantity) {
          this.cartPopupCartQuantity =
            this.cartPopupCartQuantity ||
            document.querySelector(this.selectors.cartPopupCartQuantity);
          var ariaLabel;

          if (quantity === 1) {
            ariaLabel = theme.strings.oneCartCount;
          } else if (quantity > 1) {
            ariaLabel = theme.strings.otherCartCount.replace('[count]', quantity);
          }

          this.cartPopupCartQuantity.textContent = quantity;
          this.cartPopupCartQuantity.setAttribute('aria-label', ariaLabel);
        },
      
      	_setCartCountBubble: function(quantity) {
          this.cartCountBubble =
            this.cartCountBubble ||
            document.querySelector(this.selectors.cartCountBubble);
          this.cartCount =
            this.cartCount || document.querySelector(this.selectors.cartCount);

          this.cartCountBubble.classList.remove(this.classes.hidden);
          this.cartCount.textContent = quantity;
        },

        _showCartPopup: function() {
          theme.Helpers.prepareTransition(this.cartPopupWrapper);

          this.cartPopupWrapper.classList.remove(
            this.classes.cartPopupWrapperHidden
          );
          //this._handleButtonLoadingState(false);

          slate.a11y.trapFocus({
            container: this.cartPopupWrapper,
            elementToFocus: this.cartPopup,
            namespace: 'cartPopupFocus'
          });
        },

        _hideCartPopup: function(event) {
          var setFocus = event.detail === 0 ? true : false;
          theme.Helpers.prepareTransition(this.cartPopupWrapper);
          this.cartPopupWrapper.classList.add(this.classes.cartPopupWrapperHidden);

          var cartPopupImage = document.querySelector(
            this.selectors.cartPopupImage
          );
          
          if (cartPopupImage) {
            cartPopupImage.remove();
          }
          this.cartPopupImagePlaceholder.setAttribute(
            'data-image-loading-animation',
            ''
          );

          slate.a11y.removeTrapFocus({
            container: this.cartPopupWrapper,
            namespace: 'cartPopupFocus'
          });

          if (setFocus) this.previouslyFocusedElement.focus();

          this.cartPopupWrapper.removeEventListener(
            'keyup',
            this.eventHandlers.cartPopupWrapperKeyupHandler
          );
          this.cartPopupClose.removeEventListener(
            'click',
            this.eventHandlers.hideCartPopup
          );
          this.cartPopupDismiss.removeEventListener(
            'click',
            this.eventHandlers.hideCartPopup
          );
          document.body.removeEventListener(
            'click',
            this.eventHandlers.onBodyClick
          );
        },

        _onBodyClick: function(event) {
          var target = event.target;

          if (
            target !== this.cartPopupWrapper &&
            !target.closest(this.selectors.cartPopup)
          ) {
            this._hideCartPopup(event);
          }
        },
      
        _setupCartPopupEventListeners: function() {
          this.eventHandlers.cartPopupWrapperKeyupHandler = this._cartPopupWrapperKeyupHandler.bind(
            this
          );
          this.eventHandlers.hideCartPopup = this._hideCartPopup.bind(this);
          this.eventHandlers.onBodyClick = this._onBodyClick.bind(this);

          this.cartPopupWrapper.addEventListener(
            'keyup',
            this.eventHandlers.cartPopupWrapperKeyupHandler
          );
          this.cartPopupClose.addEventListener(
            'click',
            this.eventHandlers.hideCartPopup
          );
          this.cartPopupDismiss.addEventListener(
            'click',
            this.eventHandlers.hideCartPopup
          );
          document.body.addEventListener('click', this.eventHandlers.onBodyClick);
        },
      
       	_cartPopupWrapperKeyupHandler: function(event) {
       	   if (event.keyCode === slate.utils.keyboardKeys.ESCAPE) {
            this._hideCartPopup(event);
          }
        },
      
    };
       
   
    ajaxCart.init();
  
});